(function($, undefined) {
	
	'use strict';
	var win = $(window);
	var winWidth;
	var winHeight;
	var body;
	var header;
	var navItems;
	var toggleMenuBtn;
	var mobileSubnavBtn;
	var mobileBackBtn;
	var siteSearchBtn;
	
	var toggleScroll = function () {
		var diff;
		
		if (body.hasClass('no-scroll')) {
			$('html').removeClass('no-scroll');
			body.removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = win.width();
			$('html').addClass('no-scroll');
			body.addClass('no-scroll');
			var w2 = win.width();
			diff = w2 - w1;
		}
		
		changeScrollDiff(diff);
	};
	
	var changeScrollDiff = function (diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px').css('right', -diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};
	
	var onClickMenuToggle = function () {
		if (!!body.hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			body.removeClass('menu-open');
			$('.whole-container').removeClass('pushed');
			
			header.on(transitionEnd, function(e) {
				$('html').removeClass('no-scroll');
				body.removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;
			
			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}
			
			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({scrollTop: target}, 300);
				body.animate({scrollTop: target}, 300, function () {
					openMenu();
				});
			} else {
				openMenu();
			}
		}
	};
	
	var openMenu = function () {
		body.addClass('menu-open');
		$('.whole-container').addClass('pushed');
		toggleScroll();
	};
	
	var closeMenu = function () {
		if (body.hasClass('menu-open')) {
			$('.whole-container').removeClass('pushed');
			body.removeClass('menu-open');
			toggleScroll();
		}
	};
	
	var updateNavSelected = function (page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');
		
		navItems.each(function () {
			var t = $(this);
			
			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	var openSubNav = function() {
		var t = $(this);
		var id = t.attr('data-id');

		$('.sub-menu-panel[data-id=' + id + ']').addClass('open');
	};

	var closeSubNav = function() {
		$(this).parent('.sub-menu-panel').removeClass('open');
	};
	
	var toggleSearchInput = function() {
		if ($('.site-search-form').hasClass('input-open') && $('.site-search-form').find('input').val() !== '' && $('.resp-detector-sm').css('visibility') === 'hidden') {
			$(this).prop("type", "submit");
		}

		$('.site-search-form').toggleClass('input-open');
	};

	var handleStickySectionMenu = function() {
		if (win.scrollTop() > $('.site-header').height()) {
			$('.section-menu-bar').addClass('sticky');
		} else {
			$('.section-menu-bar').removeClass('sticky');
		}
	};
	
	var handleStickyHeader = function() {
		if (win.scrollTop() > 92) {
			header.addClass('resized');
		} else {
			header.removeClass('resized');
		}
	};
	
	var init = function () {
		winWidth = win.width();
		winHeight = win.height();
		body = $('body');
		header = $('.site-header');
		navItems = $('.nav-item-link', header);
		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);
		mobileSubnavBtn = $('.mobile-menu-ctn .sub-nav-item-link');
		mobileBackBtn = $('.mobile-back-ctn');
		siteSearchBtn = $('.header-search-btn');
		
		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		mobileSubnavBtn.click(openSubNav);
		mobileBackBtn.click(closeSubNav);
		siteSearchBtn.click(toggleSearchInput);
		
		win.resize(function() {
			if (win.width() != winWidth) {
				if (body.hasClass('menu-open')) {
					toggleMenuBtn.trigger('click');
				}
				winHeight = win.height();
				winWidth = win.width();
			}
		});

		if ($('.section-menu-bar').length > 0) {
			handleStickySectionMenu();
			win.scroll(handleStickySectionMenu);
		}
		
		if (body.hasClass('sticky')) {
			handleStickyHeader();
			win.scroll(handleStickyHeader);
		}

		$('table.sortable').tablesorter({
			widgets: [ 'staticRow']
		});
	};
	
	$(init);
	
})(jQuery);
